import React from 'react'
import './Header.css';
export default function Header() {
    return (
        <div>
            <nav class="navbar">
                <div class="navbar-content">
                    <span>Welcome to rvk's Notes</span>
                    <h6>A collection of foundational notes on various subjects.</h6>
                </div>
            </nav>
        </div>
    )
}
